import { Home, Search, ShoppingCart, Heart, Info, Package } from 'lucide-react';
import { useCart } from '../context/CartContext';

const BOTTOM_NAV_Z_INDEX = 99999;

export const BottomNav = ({ 
    activeTab, 
    onTabChange, 
    onCartClick, 
    onSearchClick,
    onFavoritesClick,
    onInfoClick 
}) => {
    const { totalItems } = useCart();

    const navItems = [
        { id: 'home', icon: Home, label: 'Inicio' },
        { id: 'search', icon: Package, label: 'Productos' },
        { id: 'cart', icon: ShoppingCart, label: 'Carrito', badge: totalItems },
        { id: 'favorites', icon: Heart, label: 'Favoritos' },
        { id: 'info', icon: Info, label: 'Info' },
    ];

    const handleClick = (id) => {
        if (id === 'cart') {
            onCartClick?.();
        } else if (id === 'search') {
            onSearchClick?.();
        } else if (id === 'favorites') {
            onFavoritesClick?.();
        } else if (id === 'info') {
            onInfoClick?.();
        } else {
            onTabChange?.(id);
        }
    };

    return (
        <nav 
            className="fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200"
            data-testid="bottom-nav"
            style={{ 
                zIndex: BOTTOM_NAV_Z_INDEX,
                paddingBottom: 'env(safe-area-inset-bottom, 0)' 
            }}
        >
            <div className="flex items-center justify-around h-16 max-w-lg mx-auto">
                {navItems.map(({ id, icon: Icon, label, badge }) => (
                    <button
                        key={id}
                        onClick={() => handleClick(id)}
                        className={`flex flex-col items-center justify-center flex-1 h-full relative transition-colors ${
                            activeTab === id 
                                ? 'text-[#007a3f]' 
                                : 'text-stone-500 hover:text-stone-700'
                        }`}
                        data-testid={`nav-${id}`}
                        aria-label={label}
                    >
                        <div className="relative">
                            <Icon className="h-6 w-6" strokeWidth={activeTab === id ? 2.5 : 2} />
                            {badge > 0 && (
                                <span className="absolute -top-1.5 -right-1.5 bg-[#007a3f] text-white text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center">
                                    {badge > 9 ? '9+' : badge}
                                </span>
                            )}
                        </div>
                        <span className="text-[10px] mt-1 font-medium">{label}</span>
                    </button>
                ))}
            </div>
        </nav>
    );
};
